import React from 'react';

const timing = (props) => {
    return <span className={`u-fontSize16 u-fontWeightMedium u-textColorDark`}>{props.children}</span>
}

export default timing;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineTiming/AirlineTiming.js